import { TokenServiceClient } from '@johnlewispartnership/wtr-website-authentication/dist/service';
import config from 'config';
import getApiBaseUrl from 'utils/getApiBaseUrl';
import { isWindowAvailable } from 'utils/browser';

export const getTokenServiceClient = () => {
  if (isWindowAvailable) {
    // eslint-disable-next-line no-underscore-dangle
    if (!window.__AUTHENTICATION__) {
      // eslint-disable-next-line no-underscore-dangle
      window.__AUTHENTICATION__ = {};
    }

    // eslint-disable-next-line no-underscore-dangle
    if (!window.__AUTHENTICATION__.tokenServiceClient) {
      // eslint-disable-next-line no-underscore-dangle
      window.__AUTHENTICATION__.tokenServiceClient = new TokenServiceClient(
        getApiBaseUrl(config.services.tokenClient.path),
      );
    }

    // eslint-disable-next-line no-underscore-dangle
    return window.__AUTHENTICATION__.tokenServiceClient;
  }

  return new TokenServiceClient(getApiBaseUrl(config.services.tokenClient.path));
};
